import { OS } from 'emma-common-ts/emma';

export const OS_NAMES: { [key in OS]?: string } = {
  [OS.ANDROID]: 'Android',
  [OS.IOS]: 'iOS',
  [OS.OTHER]: $localize`Otro`,
};
